var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimedEnergy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#71778a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23 -795)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 26,
    height: 30,
    transform: "translate(23 795)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.771)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.555 809.902)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7,14a7,7,0,1,1,7-7A7.008,7.008,0,0,1,7,14ZM6.846,7.894h0A.614.614,0,0,0,7,7.914h4.87a.609.609,0,1,0,0-1.218H7.305V2.435a.609.609,0,0,0-1.218,0V7.3a.609.609,0,0,0,.608.608.645.645,0,0,0,.15-.019Z",
    transform: "translate(0.445 0.098)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-4143.643,3553.54a.852.852,0,0,1-.3-.054.866.866,0,0,1-.555-.923l1.269-9.364-3.579.827a.859.859,0,0,1-.194.022.863.863,0,0,1-.7-.363.858.858,0,0,1-.027-.957l9.958-15.827a.857.857,0,0,1,.729-.4.859.859,0,0,1,.282.048.858.858,0,0,1,.574.906l-1,9.319,3.615-.835a.858.858,0,0,1,.194-.022.862.862,0,0,1,.7.366.855.855,0,0,1,.019.962l-1.37,2.122a7.972,7.972,0,0,0-5.61,7.635,8.011,8.011,0,0,0,.058.966l-3.345,5.181a.862.862,0,0,1-.53.372A.866.866,0,0,1-4143.643,3553.54Z",
    transform: "translate(4172.635 -2730)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimedEnergy);
export default __webpack_public_path__ + "static/media/timed_energy.e31f31a1288c2b364438aacad66a1772.svg";
export { ForwardRef as ReactComponent };